






import about from "../../../assets/imageforabout/generated.jpg"
import React, { useEffect } from 'react';

import AOS from 'aos';
import 'aos/dist/aos.css'; 
export const Cyberabout = (props) => {

  useEffect(() => {
    AOS.init({
      duration: 1000, 
     
    });
  }, []);
  return (
    <div id='about1'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12 col-md-6'  >
            {' '}
            <img style={{height:300  , borderRadius:40  }}  data-aos='fade-up' src={about} className='img-responsive' alt='' />{' '}
          </div>
          <div className='col-xs-12 col-md-6'  data-aos='fade-up'>
            <div className='about-text'>
              <h2>What is Cyber Kavalan
</h2>
              <p>In today's ever-evolving threat landscape, robust cybersecurity is no longer an option – it's a necessity. RedRuby Technologies introduces Cyber Kavalan, your one-stop solution for impenetrable network defense and proactive threat mitigation.
 </p>
           
            

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
